import React from 'react'

import { Box, Skeleton } from '@mui/material'

const ExtraFieldEditSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" width="100%" gap={3}>
      <Box padding="20px 20px" display="flex" alignItems="center" gap={1}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={150} height={32} />
      </Box>
      <Box padding="10px 20px">
        <Skeleton variant="rounded" width="100%" height={56} />
      </Box>
      <Box padding="10px 20px">
        <Skeleton variant="rounded" width="100%" height={56} />
      </Box>
      <Box padding="10px 20px">
        <Skeleton variant="rounded" width="100%" height={56} />
      </Box>

      <Box flexGrow={1} minHeight={100} />
    </Box>
  )
}

export default ExtraFieldEditSkeleton
